import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_2 = { class: "card-head box-shadow bg-white d-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { class: "d-sm-flex align-items-center" }
const _hoisted_4 = { class: "fw-medium text-black-emphasis mb-0" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = {
  key: 1,
  class: "table-responsive"
}
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_10 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_11 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_12 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_13 = {
  key: 1,
  class: "form-check form-group form-switch m-0"
}
const _hoisted_14 = ["onUpdate:modelValue", "id", "onChange"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerLoading = _resolveComponent("SpinnerLoading")!
  const _component_AlertModal = _resolveComponent("AlertModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.consents !== undefined && _ctx.consents.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.$t('feature.$consents.role_enabled_consents', {role: _ctx.$t(`feature.roles.$type.${_ctx.role.type}`)})), 1 /* TEXT */)
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.consents.every((consent) => consent.linked === undefined))
              ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                  key: 0,
                  class: "mt-50"
                }))
              : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('form.title.label')), 1 /* TEXT */),
                        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('form.description.label')), 1 /* TEXT */)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createCommentVNode(" class=\"linked\" "),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.consents, (consent) => {
                        return (_openBlock(), _createElementBlock("tr", {
                          key: consent.id
                        }, [
                          _createElementVNode("td", _hoisted_10, _toDisplayString(consent.title), 1 /* TEXT */),
                          _createElementVNode("td", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", null, _toDisplayString(consent.description), 1 /* TEXT */),
                              _createElementVNode("div", null, [
                                (_ctx.loading_consent_id === consent.id)
                                  ? (_openBlock(), _createBlock(_component_SpinnerLoading, {
                                      key: 0,
                                      class: "h-auto",
                                      style: {"width":"30px"},
                                      small: true
                                    }))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "form-check-input shadow-none",
                                        type: "checkbox",
                                        role: "switch",
                                        "onUpdate:modelValue": ($event: any) => ((consent.linked) = $event),
                                        id: `${consent.id}-link`,
                                        onChange: ($event) => _ctx.updateConsent(consent, $event)
                                      }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_14), [
                                        [_vModelCheckbox, consent.linked]
                                      ])
                                    ]))
                              ])
                            ])
                          ])
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ])
                  ])
                ]))
          ])
        ]))
      : _createCommentVNode("v-if", true),
    _createVNode(_component_AlertModal, {
      id: `alertModal_${_ctx.role.id}`,
      title: _ctx.$t('feature.roles.remind_policies.title'),
      message: _ctx.$t('feature.roles.remind_policies.message', {type: _ctx.$t(`feature.roles.$type.${_ctx.role.type}`)}),
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alertModal?.hide()))
    }, null, 8 /* PROPS */, ["id", "title", "message"])
  ], 64 /* STABLE_FRAGMENT */))
}